import React from 'react';
import sourceEngine from './classroomEngineReference.webp';

/** Same approved panda locomotive for teacher Hece Treni and student Mini Görevler.
 * Shared VISUAL only: the game state, scoring, audio and animations live in
 * their respective hosts.
 */
export default function SharedTrainPandaArt() {
  return <svg className="train-engine" data-train-art="panda"
    data-classroom-art="railway-garden-v2" data-mockup-train="source-exact"
    viewBox="0 0 460 319" preserveAspectRatio="xMidYMax meet" aria-hidden="true" focusable="false">
    <g data-train-driver="panda" data-mockup-driver="exact">
      <image href={sourceEngine} x="0" y="0" width="460" height="319" />
    </g>
  </svg>;
}
